import styles from '../MaterialPreviewModal.module.css';
import '../../../../styles/buttons.css';

type Props = {
  isSubmitting: boolean;
  isPreviewLoading: boolean;
  hasChanges: boolean;
  hasCropChanges: boolean;
  onReset: () => void;
  onApplyTransform: () => void;
  onSave: () => void;
  onSaveAs: () => void;
  onDownload: () => void;
  canSave: boolean;
  canDownload: boolean;
  hasTransformApplied: boolean;
};

export function ImageEditActionBar({
  isSubmitting,
  isPreviewLoading,
  hasChanges,
  hasCropChanges,
  onReset,
  onApplyTransform,
  onSave,
  onSaveAs,
  onDownload,
  canSave,
  canDownload,
  hasTransformApplied,
}: Props) {
  const baseButtonClass = 'btn-modal';

  return (
    <div className={styles.actionBar}>
      {/* PC用: リセットボタン（左寄せ、変更がある場合のみ表示） */}
      {hasChanges && !hasTransformApplied && (
        <button type="button" className={`btn-modal-danger ${styles.actionBarDesktopOnly}`} onClick={onReset} disabled={isSubmitting || isPreviewLoading}>
          <img src="/delete_2.svg" alt="" style={{ width: '16px', height: '16px', marginRight: '6px' }} />
          リセット
        </button>
      )}
      <div className={styles.actionBarSpacer} />
      {/* PC用: 切り抜き適用ボタン（中央、クロップ変更がある場合のみ表示） */}
      {hasCropChanges && !hasTransformApplied && (
        <button
          type="button"
          className={`btn-modal-success ${styles.actionBarDesktopOnly}`}
          onClick={onApplyTransform}
          disabled={isSubmitting || isPreviewLoading}
        >
          {isPreviewLoading ? '適用中…' : '切り抜きを適用'}
        </button>
      )}
      <div className={styles.actionBarSpacer} />
      {/* フッターボタン（スマホでは固定フッターに表示） */}
      <button
        type="button"
        className={`${baseButtonClass} ${styles.actionBarFooterButton}`}
        onClick={onSave}
        disabled={isSubmitting || isPreviewLoading || !canSave}
      >
        <img src="/common_file_edit.svg" alt="" style={{ width: '16px', height: '16px', marginRight: '6px' }} />
        <span className={styles.actionBarButtonLabel}>上書き保存</span>
      </button>
      <button
        type="button"
        className={`${baseButtonClass} ${styles.actionBarFooterButton}`}
        onClick={onSaveAs}
        disabled={isSubmitting || isPreviewLoading || !canSave}
      >
        <img src="/common_file_stack.svg" alt="" style={{ width: '16px', height: '16px', marginRight: '6px' }} />
        <span className={styles.actionBarButtonLabel}>別名保存</span>
      </button>
      <button
        type="button"
        className={`${baseButtonClass} ${styles.actionBarFooterButton}`}
        onClick={onDownload}
        disabled={isSubmitting || isPreviewLoading || !canDownload}
      >
        <img src="/download_bottom.svg" alt="" style={{ width: '16px', height: '16px', marginRight: '6px' }} />
        <span className={styles.actionBarButtonLabel}>ダウンロード</span>
      </button>
    </div>
  );
}

